import { useSelector } from 'react-redux'
import { Map as ImmutableMap } from 'immutable'
import { AuthState } from '../types'

export const useAuth = (): ImmutableMap<string, string> =>
  useSelector((state: AuthState) => state.auth)
